import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const hasConsented = localStorage.getItem('cookieConsent');
    if (!hasConsented) {
      // Show consent after a small delay for better UX
      setTimeout(() => {
        setShowConsent(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    // Save consent to localStorage
    localStorage.setItem('cookieConsent', 'true');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    
    // Set analytics cookies
    setCookies();
    
    // Hide the consent modal
    setShowConsent(false);
  };

  const setCookies = () => {
    // Set essential cookies for site functionality
    document.cookie = "site_functionality=enabled; path=/; max-age=31536000; SameSite=Lax";
    
    // Set analytics cookies (you can integrate Google Analytics here later)
    document.cookie = "analytics_enabled=true; path=/; max-age=31536000; SameSite=Lax";
    
    // Set user preferences
    document.cookie = "user_preferences=enabled; path=/; max-age=31536000; SameSite=Lax";
    
    console.log("✅ Cookies установлены для аналитики и улучшения работы сайта");
  };

  if (!showConsent) {
    return null;
  }

  return (
    <>
      {/* Mobile overlay (center) */}
      <div className="sm:hidden fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-gray-800 text-white p-6 rounded-2xl max-w-sm mx-4 shadow-2xl">
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-3">
              Мы используем cookies для более удобной работы с сайтом и сбора статистики.
            </h3>
            <p className="text-gray-300 text-sm mb-4">
              Подробнее можно почитать в{" "}
              <Link 
                to="/cookie-policy" 
                className="text-purple-400 underline hover:text-purple-300"
                onClick={() => setShowConsent(false)}
              >
                Политике cookies
              </Link>
              . Оставаясь на сайте, вы соглашаетесь на применение cookies
            </p>
          </div>
          
          <button
            onClick={handleAccept}
            className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 px-4 rounded-xl transition-colors duration-200 shadow-lg"
          >
            Соглашаюсь
          </button>
        </div>
      </div>

      {/* Desktop position (bottom left) */}
      <div className="hidden sm:block fixed bottom-6 left-6 z-50 max-w-md">
        <div className="bg-gray-800 text-white p-6 rounded-2xl shadow-2xl">
          <div className="mb-4">
            <h3 className="text-lg font-semibold mb-3">
              Мы используем cookies для более удобной работы с сайтом и сбора статистики.
            </h3>
            <p className="text-gray-300 text-sm mb-4">
              Подробнее можно почитать в{" "}
              <Link 
                to="/cookie-policy" 
                className="text-purple-400 underline hover:text-purple-300"
                onClick={() => setShowConsent(false)}
              >
                Политике cookies
              </Link>
              . Оставаясь на сайте, вы соглашаетесь на применение cookies
            </p>
          </div>
          
          <button
            onClick={handleAccept}
            className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 px-4 rounded-xl transition-colors duration-200 shadow-lg"
          >
            Соглашаюсь
          </button>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;